// config/firebase.ts
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getAuth, browserLocalPersistence } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyDbknyG-fT-o7FRvemmjVxiID8g9n7QcYk",
  authDomain: "vs-sistemadeentregas.firebaseapp.com",
  projectId: "vs-sistemadeentregas",
  storageBucket: "vs-sistemadeentregas.firebasestorage.app",
  messagingSenderId: "57251751230",
  appId: "1:57251751230:web:8efef53f32233838a9786f",
  measurementId: "G-RE233KDE58"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, 'us-central1');

// Initialize Auth with browser persistence
export const auth = getAuth(app);
auth.setPersistence(browserLocalPersistence);

export default app;

